export default {"src":"/_next/static/media/trustpilot.68fdbd23.svg","height":22,"width":89,"blurWidth":0,"blurHeight":0};